import {injectable} from "inversify";
import {HistoricTournament, HistoricTournamentListResponse, ListRequest} from "../../../../generated/protocol";
import {AbstractAdminEntityService} from "../../admin/AbstractAdminEntityService";
import {AdminEntityService} from "../../admin/AdminEntityService";

export interface TournamentHistoryService extends AdminEntityService<HistoricTournament> {
    clearCache();

    getEntities(ids: string[]): Promise<HistoricTournamentListResponse[]>;

}

export interface PlayerRefund {
    // Key is used by the SimpleTable to render rows
    key?: number;
    amount: number;
    playerId: number;
    screenName: string;
}

export interface CalculatedTournamentRefundResponse {
    calculatedRefunds: PlayerRefund[];
}

export type TournamentRefundResponse = Array<{
    succesful: boolean;
    amount: number;
}>;

@injectable()
export class TournamentHistoryServiceIml extends AbstractAdminEntityService<HistoricTournament, HistoricTournamentListResponse> {

    cache: Map<string, HistoricTournament> = new Map<string, HistoricTournament>();

    constructor() {
        super("/poker/tournament-history");
    }

    list(listRequest: ListRequest): Promise<HistoricTournamentListResponse> {
        this.clearCache();
        return super.list(listRequest);
    }

    getEntity(id: string): Promise<HistoricTournament> {
        let cachedResult = this.cache.get(id);
        if (cachedResult) {
            return new Promise<HistoricTournament>((resolve, reject) => {
                resolve(cachedResult);
            });
        }
        else {
            let that = this;
            return super.getEntity(id).then<HistoricTournament>((tournament: HistoricTournament) => {
                that.cache.set(tournament.historicId, tournament);

                return tournament;
            });
        }
    }

    getEntities(ids: string[]): Promise<HistoricTournament[]> {
        let promises = [];
        for (let i = 0; i < ids.length; i++) {
            promises.push(this.getEntity(ids[i]));
        }

        return Promise.all(promises);
    }

    clearCache() {
        this.cache.clear();
    }

}



// WEBPACK FOOTER //
// ./src/app/service/poker/history/TournamentHistoryService.ts